// extracted by mini-css-extract-plugin
export default {"cards-container":"TrlhdY27y8qXiItgh1eX","island":"J31TdoL1HISUiOiCxCRR"};